import { DataQueryField } from './data-query-field.model';
import { DataQueryRelationship } from './data-query-relationship.model';
import { DataQueryInformation } from './data-query-information';

export class DataQuery {

	// Server Properties
	CourseSearch: boolean;
	CreatedBy: number;
	CreatedOn: string;
	Deleted = false;
	Delimiter = 'Comma';
	Description: string;
	DisplayMenu: boolean;
	ExportType = 'Excel';
	ID = -1;
	IncludeColumnHeadings = true;
	OtherDelimiter: string;
	OwnerID: number;
	OwnerName: string;
	Published: boolean;
	QueryName: string;
	QueryXML = '';
	SQLScript = '';
	Scope = 'Private';
	SelectedSites = '';
	SelectedSiteNames: string;
	StaffSearch: boolean;
	StudentSearch: boolean;
	UpdatedBy?: Date;
	UpdatedOn?: Date;
    SavedFromID: number;

	// Local Properties
	private _queryChanged = false;
	distinct: boolean;
	currentYearOnly = true;
	currentSchoolOnly: boolean;
	currentlyActiveStudentsOnly: boolean;
	studentEnrolledOnDate: boolean;
	studentEnrollmentDate: Date;
	courseName: string;
	siteSectionId: string | number = 0;
	reportFields: DataQueryField[] = [];
	sortFields: DataQueryField[] = [];
	filterFields: DataQueryField[] = [];
	relationships: DataQueryRelationship[] = [];
	retrievedPages = [];
	resultColumnHeaders = [];
	resultData = [];
	isUnsaved = false;
	xmlLoaded = false;
	filterTranslation = '';
	queryChangedSinceLastResult = true;
	organized = true;
	advancedFilterApplied = false;

	// Class Functions
	get allFields(): DataQueryField[] {
		// POST: obtains all of the fields
		return this.reportFields.concat(this.filterFields).concat(this.sortFields);
	}

	get queryChanged(): boolean {
		return this._queryChanged;
	}

	set queryChanged(value: boolean) {
		this._queryChanged = value;
		if (value) {
			this.queryChangedSinceLastResult = true;
		}
	}

	// Methods
	duplicate() {
		// POST: returns a duplicate of this query
		const newQuery = new DataQuery();
		Object.assign(newQuery, this);
		return newQuery;
	}

	disorganize() {
		// POST: dissociates all of the objects and categories
		this.organized = false;
		const disorganizeCallback = (field: DataQueryField) => {
			field.object = null;
			field.category = null;
			field.Filters.forEach(filter => {
				filter.field = null;
			});
		};
		this.reportFields.forEach(disorganizeCallback);
		this.sortFields.forEach(disorganizeCallback);
		this.filterFields.forEach(disorganizeCallback);
	}

	organize(information: DataQueryInformation, V10: boolean) {
		// PRE: organized information
		// POST: sets the fields properly
		this.organized = true;
		if (!information.organized) {
			information.organize();
		}
		const organizeCallback = (field: DataQueryField) => {
			// V9 has duplicate field ID's, so we need another criterion
			let infoField: DataQueryField;
			if (V10) {
				infoField = information.fields.find(f => f.ID == field.ID && f.FieldName == field.FieldName);
			} else {
				infoField = information.fields.find(f => f.ID == field.ID && f.FieldName == field.FieldName && f.CategoryID == field.CategoryID);
			}

			if (infoField) {
				field.category = infoField.category;
				field.object = infoField.object;
				field.Permission = infoField.Permission;	// We do this to preserve user permissions
			}
			// field.category = information.categories.find(category => category.ID == field.CategoryID);
			// field.object = information.objects.find(object => object.ID == field.category.ObjectID);
			field.Filters.forEach(filter => {
				filter.field = field;
			});
		};
		this.reportFields.forEach(organizeCallback);
		this.sortFields.forEach(organizeCallback);
		this.filterFields.forEach(organizeCallback);
	}
}
